import { isbot as isBotUserAgent } from "isbot";

/*
  Run this command to get the regex, check the baseline
  pnpm dlx browserslist-useragent-regexp --allowHigherVersions 'baseline 2023'
*/
const supportedBrowsers =
  /Edge?\/(12\d|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Firefox\/(12[1-9]|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(12\d|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(17\.([2-9]|\d{2,})|(1[89]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(17[._]([2-9]|\d{2,})|(1[89]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android.+Firefox\/(149|1[5-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+Chrom(ium|e)\/(14[6-9]|1[5-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)/;

function isSupportedBrowser(userAgent = navigator.userAgent) {
  return supportedBrowsers.test(userAgent);
}

function isBot() {
  if (isBotUserAgent(navigator.userAgent)) {
    return true;
  }

  // oxlint-disable-next-line typescript/no-unnecessary-condition
  return !window || !document.body;
}

export { isBot, isSupportedBrowser };
